class YSWTemplateReveal {
    constructor() {
        if (YSWTemplateReveal.instance) {
            throw new Error('New instance cannot be created');
        }

        YSWTemplateReveal.instance = this;

        if ('IntersectionObserver' in window) {
            this.lazyTemplateObserver = new IntersectionObserver((entries, observer) => {
                entries.forEach((entry) => {
                    console.log(entry);
                    if (entry.isIntersecting) {
                        this.reveal(entry.target.querySelector('template'));
                        this.lazyTemplateObserver.unobserve(entry.target);
                    }
                });
            });
        }
        this.init();
        console.log('after init');
    }

    init() {
        this.load();
    }

    load() {
        const templates = Array.from(document.querySelectorAll('template[data-ysw-lazy]:not([data-ysw-lazy="loaded"])'));
        console.log(templates);
        templates.forEach((template) => {
            this.lazyTemplateObserver.observe(template.parentElement);
        });
    }

    reveal(node) {
        const parent = node.parentElement;
        const content = node.content.cloneNode(true);
        const parentSectionId = node.getAttribute('parent-section') || null;
        parent.appendChild(content);
        node.setAttribute('data-ysw-lazy', 'loaded');

        if (parentSectionId) {
            const container = document.querySelector(`[data-section-id="${parentSectionId}"]`);
            const localeDisclosure = new theme.Disclosure(jQuery('[data-disclosure-locale]', container));
            const currencyDisclosure = new theme.Disclosure(jQuery('[data-disclosure-currency]', container));
        }
    }
}

new YSWTemplateReveal();
